/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Status_SubtitleInputs */



/**
* | output |
* | --- |
* | "Show a status notice to every customer across the app." |
*
* @param {Partner_Status_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_status_subtitle = /** @type {((inputs?: Partner_Status_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Status_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Allen Kunden app-weit einen Statushinweis anzeigen.")
	return /** @type {LocalizedString} */ ("Show a status notice to every customer across the app.")
});